import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { MatCheckbox } from '@angular/material/checkbox';
import { MatGridAvatarCssMatStyler } from '@angular/material/grid-list';

@Component({
  selector: 'ambient-circles',
  standalone: false,
  templateUrl: './ambient-circles.component.html',
  styleUrls: ['./ambient-circles.component.scss']
})
export class AmbientCirclesComponent implements OnInit {
  @ViewChild('canvas', { static: true })
    canvas: ElementRef<HTMLCanvasElement>;

  private ctx: CanvasRenderingContext2D;

  private running: boolean;


  private animatedWords: AnimatedObject[] = [];

  constructor() { }

  ngOnInit() {
    this.ctx = this.canvas.nativeElement.getContext('2d');
    this.running = true;
    this.InitiateWords();
    this.Animate();
  }

  GetRightAngleDiam(width: number, height: number): number {
    return (Math.sqrt(Math.pow(width, 2) + Math.pow(height, 2)));
  }

  InitiateWords() {
    const height = this.ctx.canvas.height;
    const width = this.ctx.canvas.width;
    for (let i = 0; i <= 5; i++) {
      this.animatedWords.push(new AnimatedObject(height,width));
    }
  }

  Animate() {
    // Check that we're still running.
    this.ctx.clearRect(0, 0, this.ctx.canvas.width,  this.ctx.canvas.height);
    if (!this.running) {
      return;
    }

    // Advance Bees. This updates the positions of all Bees.
    // Draw flock
    this.ctx.save();
    this.animatedWords.forEach(element => {
      element.Advance();
      element.Draw(this.ctx);
    });
    requestAnimationFrame(() => this.Animate());
  }
}


class AnimatedObject {
  constructor(height: number, width: number) {
    this.xEnd = width;
    this.yEnd = height;
    this.InitializeCircle();
    this.xLocaion = Math.floor(Math.random() * (width));
  }

  InitializeCircle() {
    this.size = Math.floor(Math.random() * 500) + 250;
    this.speed = 0.0002 * (Math.floor(Math.random() * 5000) + 1);
    this.yStart = Math.floor(Math.random() * this.yEnd);
    this.xLocaion = -this.size;
  }

  Advance() {
    if (this.xLocaion < this.xEnd + this.size) {
      this.xLocaion += this.speed;
    } else {
      this.InitializeCircle();
    }
  }

  Draw(ctx: CanvasRenderingContext2D) {
    ctx.beginPath();
    ctx.arc(this.xLocaion, this.yStart, this.size, 0, 2 * Math.PI, false);
    ctx.fillStyle = '#FFFFFF05';
    ctx.fill();
  }

  speed: number;
  size: number;
  xEnd: number;
  yEnd: number;
  yStart: number;
  xLocaion: number;
}
